import React from 'react'
import QuoteFormCheckboxes from './QuoteFormCheckboxes'
import QuoteFormInputFields from './QuoteFormInputFields'
import QuoteFormPreferredContact from './QuoteFormPreferredContact'
import QuoteFormMessageBox from './QuoteFormMessageBox'
import { Button } from 'antd'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { modalOptions, showModal } from '../../../redux/slices/ModalSlice'
import { useSelector } from 'react-redux'
import ModalComponent from '../../UI/ModalComponent'
import ContactModal from '../ContactModal'

const QuoteForm = () => {
    const modal = useSelector(modalOptions)
    const dispatch = useDispatch()
    const initialCheckboxState = { customWelding: { value: false, name: 'Custom Welding Job' },
    newFence: { value: false, name: 'New Fence' },
    repairFence: { value: false, name: 'Repair Fence' },
    woodFence: { value: false, name: 'Wood Fence' },
    metalFence: { value: false, name: 'Metal Fence' },
    fenceGate: { value: false, name: 'Metal Buildings/Structures' },
    drivewayGate: { value: false, name: 'Driveway Gate' },
    fenceStaining: { value: false, name: 'Fence Staining' }}

const [checkBoxes, setCheckBoxes] = React.useState(initialCheckboxState)

const initialInputState =  {firstname: { value: '', name: 'First Name', required: true },
lastname: { value: '', name: 'Last Name', required: true },
phone: { value: '', name: 'Phone Number', required: true },
email: { value: '', name: 'Email', required: true },
address: { value: '', name: 'Street Address', required: true },
city: { value: '', name: 'City', required: true },
state: { value: 'Texas', name: 'State', required: false },
zip: { value: '', name: 'Zip Code', required: true }}

const [inputFields, setInputFields] = React.useState(initialInputState)

const initialContactState = {
    text: { value: false, name: 'Text' },
    phone: { value: false, name: 'Phone' },
    email: { value: false, name: 'Email' }
}
const [preferredContactMethod, setPreferredContactMethod] = React.useState(initialContactState)
const stateReset = () => {
    setInputFields(initialInputState)
    setCheckBoxes(initialCheckboxState)
    setMessage("")
    setPreferredContactMethod(initialContactState)
}

const [message, setMessage] = React.useState('')

const sendMail = () => {
    axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/mail/sendMail`, {
        customWelding: checkBoxes.customWelding,
        newFence: checkBoxes.newFence,
        repairFence: checkBoxes.repairFence,
        woodFence: checkBoxes.woodFence,
        metalFence: checkBoxes.metalFence,
        fenceGate: checkBoxes.fenceGate,
        drivewayGate: checkBoxes.drivewayGate,
        fenceStaining: checkBoxes.fenceStaining,
        firstname: inputFields.firstname.value,
        lastname: inputFields.lastname.value,
        phone: inputFields.phone.value,
        email: inputFields.email.value,
        address: inputFields.address.value,
        city: inputFields.city.value,
        state: inputFields.state.value,
        zip: inputFields.zip.value,
        message,
        preferredPhone: preferredContactMethod.phone,
        preferredText: preferredContactMethod.text,
        preferredEmail: preferredContactMethod.email,
    })
    .then(res => {
        console.log('Send Mail Results:', res.data)
        dispatch(showModal('contact'))
        stateReset()
    })
    .catch(err => {
        console.log('Error on Send Mail:', err)
    })
}

return (
    <div className="form-container">
    <div className="bg-color-black flex-col-stretch p-15 rem-pad-width ">
        <span className="text-color-white fs-25">Request a FREE Estimate</span>
        <span className="text-color-white fs-15">
        Leave your contact information and project details below, and we will
        be in touch with you soon! This info is not shared with anyone other
        than Tangled Lead Fence and Welding personnel.
        </span>
    </div>
    <div className="bg-color-light-grey text-color-blue p-15 rem-pad-width">
        <div>
        <span className="text-color-blue">
            What kind of project do you want to do?
        </span>
        <span> Select all that apply</span>
        </div>

        {/* <img className="miw-280 w-100-P" src="https://s3.amazonaws.com/tangledlead.com/images/underconstruction.png" alt="Under Construction"/> */}

        <QuoteFormCheckboxes
        checkboxes={checkBoxes}
        setCheckBoxes={setCheckBoxes}
        />
        <QuoteFormInputFields
        inputFields={inputFields}
        setInputFields={setInputFields}
        />
        <QuoteFormPreferredContact
        preferredContactMethod={preferredContactMethod}
        setPreferredContactMethod={setPreferredContactMethod}
        />
        <QuoteFormMessageBox message={message} setMessage={setMessage} />
        <ModalComponent modalName={'contact'}>
            <ContactModal />
        </ModalComponent>
        <Button
        onClick={sendMail}
        className="btn-color w-100-P m-top-25 fw-500"
        style={{ height: '50px' }}
        >
        Submit
        </Button>
    </div>
    </div>
)
}
export default QuoteForm
